import { render, staticRenderFns } from "./prizeListAdd.vue?vue&type=template&id=0918b944&scoped=true&"
import script from "./prizeListAdd.vue?vue&type=script&lang=js&"
export * from "./prizeListAdd.vue?vue&type=script&lang=js&"
import style0 from "./prizeListAdd.vue?vue&type=style&index=0&id=0918b944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918b944",
  null
  
)

export default component.exports